import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getSalesMetrics() {
    return axios.get(`${API_URL}/operator/dashboard-metrics`, {
      headers: authHeader(),
    });
  },
  getStoreLink() {
    return axios.get(`${API_URL}/store/my-link`, { headers: authHeader() });
  },
};
